import React from 'react';
import { arrayOf, func, shape, string, bool, number } from 'prop-types';
import { useTransition, animated } from 'react-spring';
import { text } from 'polyglot/polyglot';
import clsx from 'clsx';

import BlockIcon from 'themes/common/svg/block.svg';

import Avatar from 'components/Chat/Avatar/Avatar';
import Scrollbars from 'components/Scrollbars/Scrollbars';

import styles from './UserList.module.scss';

function UserList({ users, blockedUsers, isOpen, onClickArray }) {
  const usersTransition = useTransition(isOpen, null, {
    from: {
      opacity: 0,
      transform: 'translate3d(0, 8px, 0)',
    },
    enter: {
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
    },
    leave: {
      opacity: 0,
      transform: 'translate3d(0, 8px, 0)',
    },
  });

  return usersTransition.map(
    ({ item, key, props }) =>
      item && (
        <animated.div className={styles.wrapper} key={key} style={props}>
          <Scrollbars className={styles.scroll}>
            {users
              .filter(
                // Filter unique nicknames, duplicates might occur due to several connections
                (user, index, self) =>
                  index === self.findIndex((t) => t.nickname === user.nickname)
              )
              .sort((a, b) => a.nickname.localeCompare(b.nickname))
              .map(({ nickname, avatarId }) => {
                const userBlocked = blockedUsers.includes(nickname);
                return (
                  <div
                    key={nickname}
                    className={clsx(styles.itemWrapper, {
                      [styles.blocked]: userBlocked,
                    })}
                  >
                    <button
                      type="button"
                      className={styles.item}
                      onClick={() => onClickArray[0](nickname)}
                      title={text.t('chat.modal.startPrivateChat.title')}
                    >
                      <Avatar avatar={avatarId} className={styles.avatar} />
                      <span
                        className={clsx(styles.name, {
                          [styles.blocked]: userBlocked,
                        })}
                      >
                        {nickname}
                      </span>
                    </button>
                    <button
                      type="button"
                      className={styles.item}
                      onClick={
                        () =>
                          userBlocked
                            ? onClickArray[2](nickname) // unblock user method
                            : onClickArray[1](nickname) // block user method
                      }
                      title={
                        userBlocked
                          ? text.t('chat.modal.unblockChatUser.title')
                          : text.t('chat.modal.blockChatUser.title')
                      }
                    >
                      <BlockIcon
                        className={clsx(styles.blockUserIcon, {
                          [styles.blocked]: userBlocked,
                        })}
                      />
                    </button>
                  </div>
                );
              })}
          </Scrollbars>
        </animated.div>
      )
  );
}

UserList.propTypes = {
  users: arrayOf(
    shape({
      nickname: string,
      avatarId: number,
    })
  ),
  blockedUsers: arrayOf(string),
  isOpen: bool,
  onClickArray: arrayOf(func),
};

UserList.defaultProps = {
  users: [],
  blockedUsers: [],
  isOpen: false,
  onClick: () => {},
  onClickArray: [],
};

export default UserList;
